import React, { forwardRef } from 'react';
import clsx from 'clsx';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean | string;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, error, children, ...props },
  ref
) {
  const isInvalid = Boolean(error);
  return (
    <select
      ref={ref}
      className={clsx('input-base', isInvalid && 'input-error', className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    >
      {children}
    </select>
  );
});

export default Select; 